import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const UserItem = ({ user: { login, avatar_url: avatarUrl } }) => (
  <div className="card text-center">
    <img
      src={avatarUrl}
      alt=""
      className="round-img"
      style={{ width: '60px' }}
    />
    <h3>{login}</h3>
    <div>
      <Link to={`/user/${login}`} className="btn btn-dark btn-sm-my-1">
        More Info
      </Link>
    </div>
  </div>
);

UserItem.propTypes = {
  user: PropTypes.objectOf(Array).isRequired,
};

export default UserItem;
